export const PRODUCT = {
  title: "Meal Planning and Grocery Systems",
  subtitle:
    "A simple weekly system for using what you have, planning what you need, and tracking grocery spending.",
  price: "$4.95",
  brand: "Meal Planning and Grocery Systems",
  format: "Digital PDF workbook",
  cover: "/assets/workbook-cover.jpg",
};

export const PILLARS = [
  {
    n: "01",
    title: "Use what you have",
    text: "Start each week by checking the pantry, fridge and freezer, so the food already in your kitchen shapes the plan.",
  },
  {
    n: "02",
    title: "Plan what you need",
    text: "Map out the week's meals day by day, then turn the gaps into one focused grocery list.",
  },
  {
    n: "03",
    title: "Track grocery spending",
    text: "Write down what each shop costs and see where your grocery budget actually goes, week after week.",
  },
];

export const WEEK = [
  { day: "Check", note: "What's already on the shelves?" },
  { day: "Plan", note: "Meals for the week ahead" },
  { day: "List", note: "Only what's missing" },
  { day: "Shop", note: "Stick to the list" },
  { day: "Track", note: "Log what you spent" },
];

export const PAGES = [
  { src: "/assets/ws-use-what-you-have.jpg", title: "Use what you have", text: "Pantry, fridge and freezer check-in." },
  { src: "/assets/ws-weekly-meal-plan.jpg", title: "Weekly meal plan", text: "Seven days of meals at a glance." },
  { src: "/assets/ws-grocery-tracker.jpg", title: "Grocery spending tracker", text: "Planned versus spent, every shop." },
];

export const FAQS = [
  {
    q: "What format is the workbook?",
    a: "It's a digital PDF. Pay securely by card through Stripe and your download unlocks right after payment, and you can use it on screen or print it at home.",
  },
  {
    q: "Who is it for?",
    a: "Anyone feeding themselves or a household who wants a simple weekly routine for meals and a clearer view of grocery spending.",
  },
  {
    q: "Do I need any special apps?",
    a: "No. A PDF reader, or a printer and a pen, is all you need.",
  },
  {
    q: "Can I give it as a gift?",
    a: "Yes. Choose \"Buy as a gift\", add your friend's name and email and an optional note. Once you've paid, we email them their download link.",
  },
  {
    q: "Can I reuse it every week?",
    a: "Yes. The system is built around a weekly routine, so you can print fresh copies whenever you start a new week.",
  },
];
